import { ColumnDefWithFilters, ColumnGroup } from '../types'
import { usePageInfo } from 'app/frontend/base/config/queries'
import { useSimpleColumns } from '../utils'
import { useAudit } from '../context'
import { useMemo } from 'react'

export const useDungeonsOverallColumns = (): ColumnDefWithFilters => {
  const { visibleMembers } = useAudit()
  const {
    data: { currentSeason },
  } = usePageInfo()

  const colorsByCharacter = useMemo(() => {
    return Object.fromEntries(
      visibleMembers.map((member) => [
        member.characterReference.id,
        member.mythicRatingColor,
      ]),
    )
  }, [visibleMembers])

  const collectionGroups: ColumnGroup[] = [
    {
      id: 'overall',
      header: 'Overall',
      subColumns: [
        {
          id: 'total_rating',
          header: 'Rating',
          field: 'm+_score',
          cellWrapper: (value, member) => (
            <span
              style={{
                color:
                  colorsByCharacter[member.characterReference.id]?.overall ||
                  'inherit',
              }}
            >
              {value}
            </span>
          ),
        },
        {
          id: 'total_runs',
          header: 'Runs',
          field: 'season_mythic_dungeons',
        },
      ],
    },
    ...(currentSeason.keystone_dungeons ?? []).map<ColumnGroup>((dungeon) => ({
      id: `keystone_${dungeon.id}`,
      header: dungeon.name,
      rankFields: null,
      subColumns: [
        {
          id: `highest_level_${dungeon.key}`,
          header: 'Rating',
          field: `${dungeon.key}_score`,
          cellWrapper: (value, member) => (
            <span
              style={{
                color:
                  colorsByCharacter[member.characterReference.id]?.[
                    dungeon.key
                  ] || 'inherit',
              }}
            >
              {value}
            </span>
          ),
        },
        {
          id: `total_${dungeon.key}`,
          header: 'Runs',
          field: `${dungeon.key}_total`,
        },
      ],
    })),
  ]

  const columns = useSimpleColumns(collectionGroups)

  return {
    columns,
    initialSortBy: [{ id: 'total_rating', desc: true }],
  }
}
